import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface InsertConversationTRPCInput {
  ParentId?: string | null;
  Content: string;
}

export const useInsertConversationTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.conversation.insert.mutationOptions({
      onSuccess: async () => {
        // A new conversation seeds its first comment — the editor re-reads the
        // comment list per conversation via
        // `comment.commentsByConversationId`, so invalidate that family.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    insertConversation: async (
      input: InsertConversationTRPCInput
    ): Promise<{ Id: string }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
